/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import BeneficiaryTransactionDetails from "../../../../containers/Transactions/BeneficiaryTransactions/BeneficiaryTransactionDetails";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import LargePopupRedirect from "../../../_utils/CommonPopups/CommonLargePopupRedirect";

function BeneficiaryTransactionDetailsPopup({
  closeBeneTxnDetailModal,
  bene_txn_id,
  type,
  setTransactionFilterData,
  setTransactionFilterID,
  typeMulti,
  typeSingle = "Additional_Details",
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(disableSwitcher());
    return () => {
      dispatch(enableSwitcher());
    };
  }, []);

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <LargePopupRedirect
        headerTitle="Beneficiary transaction details"
        headersubtext=""
        isfullViewrequired={true}
        fullviewhandleFunction={() => {
          closeBeneTxnDetailModal();
          navigate(
            `/beneficiary_transaction_dashboard/beneficiary_transaction_view_all/beneficiary_transaction_detail_page/${bene_txn_id}`,
          );
        }}
        fullviewisDisabled={false}
        fullviewdisabledBgColor="var(--text-disabled)"
        fullviewenabledBgColor="var(--primary-nav)"
        fullviewenabledTextColor="var(--text-primary)"
        fullviewhoverOption="white"
        fullviewicon={ICONS?.REDIRECT}
        closeiconhandleFunction={closeBeneTxnDetailModal}
        closeiconisDisabled={false}
        closeiconenabledBgColor="var(--primary-nav)"
        closeicondisabledBgColor="var(--text-disabled)"
        closeiconhoverOption="white"
        closeicon={ICONS?.CLOSE}
        isbottomSectionneed={false}
        bottomHeaderTextNeed={false}
      >
        <BeneficiaryTransactionDetails
          bene_txn_id={bene_txn_id}
          closeBeneTxnDetailModal={closeBeneTxnDetailModal}
          type={type}
          setTransactionFilterData={setTransactionFilterData}
          setTransactionFilterID={setTransactionFilterID}
          typeMulti={typeMulti}
          typeSingle={typeSingle}
        />
      </LargePopupRedirect>
    </div>
  );
}

export default BeneficiaryTransactionDetailsPopup;
